import { Location } from 'src/app/models/turns-models/location.model';
import { Injectable, isDevMode } from '@angular/core';
import { EMPTY, Observable, Subject } from 'rxjs';
import { UserService } from 'src/app/services/user-service/user.service';
import { LocationsDesksTurnsDaoService } from 'src/app/dao/turns-dao-services/locations-desks-turns-dao-service/locations-desks-turns-dao.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class LocationsTurnsService {

  accessToken = ['TUR', 'CTR'];
  refreshLocationsListener = new Subject<any>();
  refreshLocationListener = new Subject<any>();
  refreshTurnsListListener = new Subject<any>();
  searchLocationsListener = new Subject<any>();
  filterLocationsListener = new Subject<any>();
  toggleLocationsDispositionListener = new Subject<any>();

  constructor(private locationsDesksTurnsDaoService: LocationsDesksTurnsDaoService,
              private userStorageService: UserStorageService,
              private userService: UserService) { }

  public getLocationList() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.getLocationList(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const locations = new Array<Location>();
          o['data']['deskLocationList'].forEach(
            (l) => {
              locations.push(Object.assign(new Location(), l));
            }
          );
          return locations;
        })
      );
    }
    return EMPTY;
  }

  public getLocationListByDesk(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.getLocationListByDesk(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const locations = new Array<Location>();
          o['data']['deskLocationList'].forEach(
            (l) => {
              locations.push(Object.assign(new Location(), l));
            }
          );
          return locations;
        })
      );
    }
    return EMPTY;
  }

  public getTurnListByDesk(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.getTurnListByDesk(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['turnList'])
      );
    }
    return EMPTY;
  }

  public getLocation(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.getLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const location = new Location();
          Object.assign(location, o['data']['deskLocationDetails']);
          return location;
        })
      );
    }
    return EMPTY;
  }

  public addNewLocation(active, centerInternalId, name, numeration, status, iotInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.addNewLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), active, centerInternalId, name, numeration, status, iotInternalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateLocation(internalId, active, centerInternalId, name, numeration, status, iotInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.updateLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, active, centerInternalId, name, numeration, status, iotInternalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public deleteLocation(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.deleteLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateStatusLocation(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.updateStatusLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public closeLocation(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.closeLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public openLocation(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.openLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public getLocationLiveInfo(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.getLocationLiveInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data'])
      );
    }
    return EMPTY;
  }

  public nextDeskLocation(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.nextDeskLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public callBackLastTurnAtLocation(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.callBackLastTurnAtLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public requeueLastTurnAtLocation(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.requeueLastTurnAtLocation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public nextDeskLocationByTurn(locationInternalId, turnInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.locationsDesksTurnsDaoService.nextDeskLocationByTurn(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), locationInternalId, turnInternalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public refreshLocations() {
    this.refreshLocationsListener.next();
  }

  public refreshLocationsListen() {
    return this.refreshLocationsListener.asObservable();
  }

  public refreshLocation() {
    this.refreshLocationListener.next();
  }

  public refreshTurnslistListen() {
    return this.refreshTurnsListListener.asObservable();
  }

  public refreshTurnsList(locationId) {
    this.refreshTurnsListListener.next(locationId);
  }

  public refreshLocationListen() {
    return this.refreshLocationListener.asObservable();
  }

  public searchLocations(filterKey) {
    this.searchLocationsListener.next(filterKey);
  }

  public searchLocationsListen() {
    return this.searchLocationsListener.asObservable();
  }

  public filterLocations(opts) {
    this.filterLocationsListener.next(opts);
  }

  public filterLocationsListen() {
    return this.filterLocationsListener.asObservable();
  }

  public toggleLocationsDisposition(viewDis) {
    this.toggleLocationsDispositionListener.next(viewDis);
  }

  public toggleLocationsDispositionListen() {
    return this.toggleLocationsDispositionListener.asObservable();
  }
}
